import React from "react";

import { remoStyles } from "@common/styles";
import { Input, TextArea } from "@components";
import { IApiKey } from "@common/models";

const remoHeaderStyle = { ...remoStyles.header, marginBottom: "10px" };
const remoCancelButtonStyle = {
  ...remoStyles.okButton,
  backgroundColor: "#444"
};

const remoDeleteButtonStyle = { ...remoStyles.okButton, backgroundColor: "#ed3535"}

export interface IApiKeyModalProps {
  apiKey: IApiKey;
  changeName: (apiKeyName: string) => void;
  delete: (apiKeyName: string) => void;
  cancel: () => void;
}

export interface IApiKeyModalState {
  apiKeyName: string;
}

class ApiKeyModal extends React.Component<
  IApiKeyModalProps,
  IApiKeyModalState
> {
  constructor(props: IApiKeyModalProps) {
    super(props);
    this.state = {
      apiKeyName: props.apiKey ? props.apiKey.tokenName : ""
    };
  }

  public render() {
    const {apiKey, changeName, cancel} = this.props;
    const {apiKeyName} = this.state;

    return (
      <div style={remoStyles.container as any} className="flexList">
        <div style={remoHeaderStyle as any}>Rediger API-nøkkel</div>
        <div style={remoStyles.content as any}>
          <div style={{ fontWeight: "bold" }}>Nåværende navn</div>
          <div>{apiKey.tokenName}</div>
        </div>
        <div style={remoStyles.content as any}>
          <Input
            name="apiKeyNewName"
            label="Nytt navn"
            value={apiKeyName}
            type="text"
            onChange={this.handleNewApiKeyName}
          />
        </div>
        <div style={remoStyles.content as any}>
          <TextArea
            readOnly={true}
            label="Token"
            value={apiKey.accessToken}
          />
        </div>
        <button
          style={remoStyles.okButton as any}
          onClick={() => changeName(apiKeyName)}
        >
          Lagre
        </button>
        <button style={remoDeleteButtonStyle as any} onClick={() => this.props.delete(apiKeyName)}>Slett</button>
        <button style={remoCancelButtonStyle as any} onClick={cancel}>
          Avbryt
        </button>
      </div>
    );
  }

  private handleNewApiKeyName = apiKeyName => {
    this.setState({ apiKeyName });
  };
}

export default ApiKeyModal;
